'use strict';

import * as THREE from 'three';

export let icon360 = {
  get360Icon : (position, rotation, scale, name) => {
    let iconGroup = new THREE.Group();
    iconGroup.name = name;
    iconGroup.position.set(position.x, position.y, position.z);
    iconGroup.rotation.set(rotation.x, rotation.y, rotation.z);
    iconGroup.scale.set(scale.x, scale.y, scale.z);
    // add group end

    // add circles
    const geometry = new THREE.TorusGeometry( 100 * 0.02907, 6 * 0.02907, 10, 24 );
    const material = new THREE.MeshPhongMaterial( {
      color : new THREE.Color(0xC8AA4A),
      specular: new THREE.Color(0xCBBE08),
      emissive: new THREE.Color(0xBDC8D6),
      emissiveIntensity: 0.2
    } );
    let circle1 = new THREE.Mesh( geometry, material);
    let circle2 = circle1.clone();
    let text;
    iconGroup.add(circle1);
    iconGroup.add(circle2);
    // add circles end

    //add 360 text 2D Render

    const geometryCircle = new THREE.CircleGeometry( 2.5, 32 );
    const materialCircle = new THREE.MeshBasicMaterial({
      color: 0x000000,
      transparent: true,
      opacity: 0.45,
    });
    const circlePlane = new THREE.Mesh( geometryCircle, materialCircle );

    // add 360 text
    const fontloader = new THREE.FontLoader();
    fontloader.load( 'fonts/almoni/almoni-nue-bold.json', font => {
      let matLite = new THREE.MeshBasicMaterial( {
        color : 0xC8AA4A,
        side: THREE.DoubleSide
      });
      const message = '360';
      const shapes = font.generateShapes( message, 50 * 0.02907);
      const geometry = new THREE.ShapeBufferGeometry( shapes );
      geometry.computeBoundingBox();
      let xMid = - 0.5 * ( geometry.boundingBox.max.x - geometry.boundingBox.min.x );
      geometry.translate( xMid, 0, 0 );

      text = new THREE.Mesh( geometry, matLite );
      text.position.set(-0.37846056424293384,  -0.7050286572584877,  0.0791229718064399);
      text.name = '360-text';

      const textBcg = text.clone();
      textBcg.material = new THREE.MeshBasicMaterial( {
        color : 0x000000,
        transparent: true,
        opacity: 1,
        side: THREE.DoubleSide,
        depthFunc: THREE.NeverDepth
      });
      textBcg.position.set(-0.328,  -0.805,  0.059);
      textBcg.name = 'textBcg';

      iconGroup.add(circlePlane);
      iconGroup.add(text);
      iconGroup.add(textBcg);
      {
        let message = 'o';
        const shapes = font.generateShapes( message, 30 * 0.02907);
        const geometry = new THREE.ShapeBufferGeometry( shapes );
        geometry.computeBoundingBox();
        let xMid = - 0.5 * ( geometry.boundingBox.max.x - geometry.boundingBox.min.x );
        geometry.translate( xMid, 0, 0 );

        text = new THREE.Mesh( geometry, matLite );
        text.position.set(1.4422313251781014,  0.16951626357985675,  0.042);
        text.name = '360-text-0';
        iconGroup.add(text);
      }
    });
    return iconGroup;
  }
}